import { replaceRouteParams } from '../../../../helpers/url'

export const findNewLineTo = ({ populatedParams, isParamsRelatedLink, path }) => {
  if (isParamsRelatedLink) {
    return replaceRouteParams(path, populatedParams)
  } else {
    return path
  }
}
